import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { AUTH_CHALLENGES } from "@/constants/auth";
import { useAuth } from "@/context/auth/AuthContext";
import { usePortalNavigationAccess } from "@/hooks/usePortalNavigationAccess";
import { MFA_CHALLENGE_PAGE, MFA_SETUP_PAGE, SET_PASSWORD_PAGE } from "./paths";
export default function LoginRoute({ children }) {
    const { isAuthenticated, challengeData, mfaSetupRequired, initialized } = useAuth();
    const { defaultPage, isLoading: isNavigationAccessLoading } = usePortalNavigationAccess(isAuthenticated);
    if (!initialized) {
        return null;
    }
    if (isAuthenticated && isNavigationAccessLoading) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    if (mfaSetupRequired) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: MFA_SETUP_PAGE,
            replace: true
        });
    }
    if (challengeData) {
        switch(challengeData.challengeName){
            case AUTH_CHALLENGES.NEW_PASSWORD_REQUIRED:
                return /*#__PURE__*/ _jsx(Navigate, {
                    to: SET_PASSWORD_PAGE,
                    replace: true
                });
            case AUTH_CHALLENGES.SOFTWARE_TOKEN_MFA:
            case AUTH_CHALLENGES.SMS_MFA:
                return /*#__PURE__*/ _jsx(Navigate, {
                    to: MFA_CHALLENGE_PAGE,
                    replace: true
                });
            case AUTH_CHALLENGES.MFA_SETUP:
                return /*#__PURE__*/ _jsx(Navigate, {
                    to: MFA_SETUP_PAGE,
                    replace: true
                });
        }
    }
    if (isAuthenticated) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: defaultPage,
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
